import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Bell } from "lucide-react";

const ALERT_TYPES = [
  { key: "strong_buy", label: "Strong Buy Signals", color: "#00FFA3" },
  { key: "strong_sell", label: "Strong Sell Signals", color: "#FF3B30" },
  { key: "entry_hit", label: "Entry Price Hit", color: "#00E0FF" },
];

export default function AlertSettingsDialog({
  open,
  onOpenChange,
  alertSettings,
  onUpdate,
  pushSupported,
  onTogglePush,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="glass-solid max-w-[95vw] sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-white text-lg" style={{ fontFamily: 'Unbounded' }}>
            ALERT SETTINGS
          </DialogTitle>
          <DialogDescription className="text-xs text-gray-500">
            Choose how you get notified about trading signals
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-5 mt-3">
          {/* In-App Alerts */}
          <div className="flex items-center justify-between p-3 glass-effect rounded-lg">
            <div className="flex items-center gap-3">
              <Bell className="w-5 h-5 text-[#00E0FF]" />
              <div>
                <div className="text-sm font-semibold text-white">In-App Alerts</div>
                <div className="text-xs text-gray-400">Real-time notifications in the app</div>
              </div>
            </div>
            <button
              data-testid="toggle-in-app"
              onClick={() => onUpdate({ ...alertSettings, in_app: !alertSettings.in_app })}
              className={`w-10 h-6 rounded-full transition-colors ${alertSettings.in_app ? 'bg-[#00E0FF]' : 'bg-gray-600'}`}
            >
              <div className={`w-4 h-4 bg-white rounded-full transition-transform mx-1 ${alertSettings.in_app ? 'translate-x-4' : ''}`} />
            </button>
          </div>

          {/* Push Notifications */}
          {pushSupported && (
            <div className="flex items-center justify-between p-3 glass-effect rounded-lg">
              <div className="flex items-center gap-3">
                <Bell className="w-5 h-5 text-[#F59E0B]" />
                <div>
                  <div className="text-sm font-semibold text-white">Push Notifications</div>
                  <div className="text-xs text-gray-400">Get alerts even when the app is closed</div>
                </div>
              </div>
              <button
                data-testid="toggle-push"
                onClick={onTogglePush}
                className={`w-10 h-6 rounded-full transition-colors ${alertSettings.push ? 'bg-[#F59E0B]' : 'bg-gray-600'}`}
              >
                <div className={`w-4 h-4 bg-white rounded-full transition-transform mx-1 ${alertSettings.push ? 'translate-x-4' : ''}`} />
              </button>
            </div>
          )}

          {/* Alert Types */}
          <div className="p-3 glass-effect rounded-lg">
            <div className="text-sm font-semibold text-white mb-3">Alert Types</div>
            <div className="space-y-2">
              {ALERT_TYPES.map(type => (
                <div key={type.key} className="flex items-center justify-between py-1">
                  <span className="text-xs text-gray-300">{type.label}</span>
                  <button
                    onClick={() => onUpdate({
                      ...alertSettings,
                      alert_types: { ...alertSettings.alert_types, [type.key]: !alertSettings.alert_types?.[type.key] }
                    })}
                    className={`w-8 h-5 rounded-full transition-colors ${alertSettings.alert_types?.[type.key] ? `bg-[${type.color}]` : 'bg-gray-600'}`}
                  >
                    <div className={`w-3 h-3 bg-white rounded-full transition-transform mx-1 ${alertSettings.alert_types?.[type.key] ? 'translate-x-3' : ''}`} />
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
